import React, { Component, createRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import ListItem from "@material-ui/core/ListItem";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";

import CancelIcon from "@material-ui/icons/Cancel";

import { useStyles } from "./StudentMarksDetail.css";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import ObtainedMarksRegister from "./ObtainedMarksRegister/ObtainedMarksRegister";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../Components/FormLoader/FormLoader";

class StudentMarksDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [
        { name: "S.N." },
        { name: "Subjects" },
        { name: "Status" },
        { name: "Theory" },
        { name: "Practical" },
        { name: "Result" },
        { name: "Actions" },
      ],
      marksId: "",
      examList: [],
      data: {
        marks: [],
      },
      marksRef: createRef(),
      existStatus: false,
      loading: false,
    };
  }

  componentDidMount() {
    this.getMarks();
  }

  getMarks = async () => {
    try {
      const response = await Axios.get(`${url}/api/marks`, {
        params: {
          session: this.props.examConfig.session,
          examType: this.props.examConfig.exam,
          studentClass: this.props.examConfig.class,
          faculty: this.props.examConfig.faculty
            ? this.props.examConfig.faculty
            : null,
          group: this.props.examConfig.group
            ? this.props.examConfig.group
            : null,
          section: this.props.examConfig.section,
          studentId: this.props.studentId,
        },
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.marks.length !== 0) {
        this.setState({
          data: {
            marks: response.data.marks[0].marks,
          },
          marksId: response.data.marks[0]._id,
          existStatus: false,
        });
      } else {
        this.setState({
          data: {
            marks: this.props.initialMarksList,
          },
          marksId: "",
          existStatus: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getMarks();
      }
    }
  };

  handleMarks = (data) => {
    let changedData = this.state.data.marks.map((mark, index) =>
      mark.subjectName === data.subjectName ? data : mark
    );
    this.setState({
      data: { ...this.state.data, marks: changedData },
    });
  };

  filterData = (data) => {
    let changedData = data;
    if (data.faculty === "") {
      delete changedData.faculty;
    }

    if (data.group === "") {
      delete changedData.group;
    }

    return changedData;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      this.setState({ loading: true });
      let newData = {
        studentId: this.props.student._id,
        session: this.props.examConfig.session,
        examType: this.props.examConfig.exam,
        studentClass: this.props.examConfig.class,
        section: this.props.examConfig.section,
        faculty: this.props.examConfig.faculty,
        group: this.props.examConfig.group,
        marks: this.state.data.marks,
      };
      let data = this.filterData(newData);
      if (this.state.existStatus === false) {
        const response = await Axios.put(
          `${url}/api/marks/${this.state.marksId}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          }
        );
        if (response.data.message === "Marks updated successfully") {
          this.setState({ loading: false });
          this.props.handleCancelDetailStatus();
        }
      } else {
        const response = await Axios.post(`${url}/api/marks`, data, {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        });
        if (response.data.message === "Marks added successfully") {
          this.setState({ loading: false });
          this.props.handleCancelDetailStatus();
        }
      }
    } catch (error) {
      this.setState({ loading: false });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e);
      }
    }
  };

  handleUpdate = async (e) => {
    e.preventDefault();
    try {
      let newData = {
        studentId: this.props.student._id,
        session: this.props.examConfig.session,
        examType: this.props.examConfig.exam,
        studentClass: this.props.examConfig.class,
        section: this.props.examConfig.section,
        faculty: this.props.examConfig.faculty,
        group: this.props.examConfig.group,
        marks: this.state.data.marks,
      };
      let data = this.filterData(newData);
      const response = await Axios.put(
        `${url}/api/marks/${this.state.marksId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Marks updated successfully") {
        this.props.handleCancelDetailStatus();
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleUpdate(e);
      }
    }
  };

  render() {
    const { classes, student, examConfig } = this.props;
    return (
      <div className={classes.root}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <b style={{ flexGrow: 1, fontSize: 18 }}>
            Register Marks({examConfig.exam})
          </b>
          <Tooltip
            arrow
            title="Cancel"
            onClick={this.props.handleCancelDetailStatus}
            className={classes.tooltip}
          >
            <CancelIcon />
          </Tooltip>
        </div>
        <ListItem divider>
          <b style={{ flexGrow: 1 }}>Student Name:</b>
          <div>
            {student.firstName} {student.middleName} {student.lastName}
          </div>
        </ListItem>
        {this.props.marksDetails.length !== 0 && (
          <div>
            <ul style={{ textAlign: "justify" }}>
              <li>Enter absent or present for each subject</li>
              <li>
                After entering marks of each subject please click on add button
              </li>
            </ul>

            <TableContainer>
              <Table>
                <CustomTableHead column={this.state.column} />

                <TableBody>
                  {this.state.data.marks.map((subject, index) => (
                    <TableRow key={index}>
                      <ObtainedMarksRegister
                        key={index}
                        index={index}
                        data={subject}
                        marksId={this.state.marksId}
                        studentId={this.props.student._id}
                        marksStatus={this.state.existStatus}
                        handleMarks={this.handleMarks}
                        handleCancelDetailStatus={
                          this.props.handleCancelDetailStatus
                        }
                      />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
        <br />
        <div style={{ display: "flex", alignItems: "center" }}>
          <Button
            variant="outlined"
            className={classes.buttonStyle}
            onClick={this.handleSubmit}
          >
            {this.state.existStatus ? "Submit" : "Update"}
          </Button>
          {this.state.loading && <FormLoader />}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(StudentMarksDetail)));
